const listaDeTratativas = (state) => {
  return state.tratativas || []
}

const loadingTratativa = (state) => {
  return state.buscando
}

const paginacao = (state) => {
  return state.paginacao || null
}

export {
  listaDeTratativas,
  loadingTratativa,
  paginacao
}